var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"flat":""}},[_c('v-row',{staticClass:"mx-2"},_vm._l((_vm.filteredArray),function(connector,index){return _c('v-col',{key:index,attrs:{"cols":"auto"}},[_c('v-img',{staticClass:"mx-auto",style:(_vm.disableGrayScale
            ? ''
            : _vm.isCompatible(connector)
            ? ''
            : 'filter: grayscale(1);'),attrs:{"src":connector.getPlugIconSrc(),"width":"50","height":"50","contain":""}}),_c('v-card-text',[_vm._v(_vm._s(connector.displayName))])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }